import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/kentroouvidoria")({
  beforeLoad: () => {
    throw redirect({ to: "/ouvidoria", replace: true });
  },
  component: () => null,
});
